import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getItems(params = {}) {
    return axiosIns.get('/v2/inventory/inventory_items', {
      params: snakecaseKeys(params),
    })
  },

  getItem(id) {
    return axiosIns.get(`/v2/inventory/inventory_items/${id}`)
  },

  create({
    itemId,
    unitType,
    currentQuantity = 0,
    standardQuantity = null,
    bottleCapacityMl = null,
    servingSizeMl = null,
  }) {
    return axiosIns.post(
      '/v2/inventory/inventory_items',
      snakecaseKeys({
        inventoryItem: {
          itemId,
          unitType,
          currentQuantity,
          standardQuantity,
          bottleCapacityMl,
          servingSizeMl,
        },
      }),
    )
  },

  update(id, {
    unitType = null,
    standardQuantity = null,
    bottleCapacityMl = null,
    servingSizeMl = null,
  }) {
    return axiosIns.patch(
      `/v2/inventory/inventory_items/${id}`,
      snakecaseKeys({
        inventoryItem: {
          unitType,
          standardQuantity,
          bottleCapacityMl,
          servingSizeMl,
        },
      }),
    )
  },

  destroy(id) {
    return axiosIns.delete(`/v2/inventory/inventory_items/${id}`)
  },

  bulkDestroy(ids) {
    return axiosIns.post(
      '/v2/inventory/inventory_items/bulk_destroy',
      snakecaseKeys({ ids }),
    )
  },

  replenishment(id, { quantity }) {
    return axiosIns.post(
      `/v2/inventory/inventory_items/${id}/replenishment`,
      snakecaseKeys({ quantity }),
    )
  },

  adjustment(id, { adjustedQuantity }) {
    return axiosIns.post(
      `/v2/inventory/inventory_items/${id}/adjustment`,
      snakecaseKeys({ adjustedQuantity }),
    )
  },
}
